<ul class="tab-buttons-group">
  <li *ngFor="let button of buttonsConfig" class="tab-buttons-group__item">
    <app-tab-buttons-group-item
      [text]="button.text"
      [isActive]="isActive(button.value)"
      (click)="selectItem(button.value)"
    ></app-tab-buttons-group-item>
  </li>
</ul>
